import type { FaireProductEntity } from "../../entity_types/product";

export const p_pjzga8zj8q: FaireProductEntity = {
  token: "p_pjzga8zj8q",
  type: "product",
  name: "Woodsmoke & Fir Candle | Rustic Evergreen Scent | Soy Wax",
  brandName: "Pacific North Wicks",
  imageUrl:
    "https://cdn.faire.com/fastly/37c7dde908ee024097201a3f652de3256ca27f136f4e5959da7d8fa68c856362.png",
  priceDollars: 12,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/51795cfdc43763249c9cd335827d0972ca6fa8c8a9e56175a5dd35807ba089b8.png",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
